import { DropdownItem } from '../../../shared';

export interface State {
  stateCode: string;
  countryId: number;
  countryCode: string;
  countryName: string;
  id: number;
  name: string;
}

export interface Country {
  id: number;
  countryCode: string;
  phoneCode: string;
  emoji: string;
  emojiU: string;
  name: string;
  states: State[];
}

export enum CountryType {
  Canada = 1,
  US = 2,
}
/*
Example usage:
  // set the form control to Canada by default, must set explicitly set nonNullable, otherwise form.reset() will set it to null
  readonly countryFormControl = new FormControl<number>(CountryHelper.defaultCountry, {
    nonNullable: true,
    validators: Validators.required,
  });

  private readonly currentCountryId = toSignal(this.countryFormControl.valueChanges, {
    initialValue: CountryHelper.defaultCountry,
  });
  readonly countries = toSignal(this.lookupTypeRepository.getCountryTypes(), { initialValue: [] });
  readonly countryDropdownOptions = computed(() => CountryHelper.getCountriesDropdownItems(this.countries()));
  readonly stateDropdownOptions = computed(() =>
    CountryHelper.getStatesDropdownItems(this.countries().find(c => c.id === this.currentCountryId()) ?? null),
  );

  // update province form control when country is changed
  constructor() {
    effect(() => {
      const stateDropdownOptions = this.stateDropdownOptions();
      // could wipe out the form value if the countries/state not loaded yet
      if (!stateDropdownOptions.length) return;

      const selectedProvinceId = this.provinceFormControl.value;

      // reset state form if the country is changed and state is not found in a new country
      if (!stateDropdownOptions.some(s => s.value === selectedProvinceId)) {
        this.provinceFormControl.setValue(null);
      }
    });
  }
 */
export class CountryHelper {
  static defaultCountry = CountryType.Canada;

  static getStatesDropdownItems(countries: Country | Country[] | null): DropdownItem[] {
    if (countries === null) {
      return [];
    }
    const countryArray = Array.isArray(countries) ? countries : [countries];

    return countryArray.flatMap(c => c.states.map(s => new DropdownItem<number>(s.name ?? '', s.id)));
  }

  static getCountriesDropdownItems(countries: Country | Country[] | null): DropdownItem[] {
    if (countries === null) {
      return [];
    }
    const countryArray = Array.isArray(countries) ? countries : [countries];

    return countryArray.map(c => new DropdownItem<number>(c.name ?? '', c.id));
  }
}
